import styled from 'styled-components';

export const Number = styled.text.attrs({
  fill: ({ theme }) => theme.base.PastelBlue,
  textAnchor: 'middle',
  y: 25,
  style: ({ theme }) => ({
    fontFamily: theme.numbersFontFamily,
    fontSize: '2em',
    fontWeight: '700',
  }),
})``;

export const Label = styled.text.attrs({
  fill: ({ theme }) => theme.base.PastelBlue,
  textAnchor: 'middle',
  style: ({ theme }) => ({
    fontFamily: theme.defaultFontFamily,
    fontWeight: theme.defaultFontWeight,
    fontSize: '0.9em',
  }),
})``;



// WEBPACK FOOTER //
// ./src/components/CirclePackingChart/Circle/Circle.style.js